import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-listing-five',
  templateUrl: './listing-five.component.html',
  styleUrls: ['./listing-five.component.scss']
})
export class ListingFiveComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
